import { useState } from 'react';
import { FormError } from '../formErrorScroll';
import './style.scss';

export type PriceInputProps = {
  price: number | null | undefined;
  name?: string;
  label?: string;
  placeholder?: string;
  unitName: string;
  onChange: (value: number | null) => void;
  onBlur?: (e: React.FocusEvent<any, Element>) => void;
  error?: string;
  maxLength?: number;
  disabled?: boolean;
};

export const PriceInput = ({ price, disabled, name, label, placeholder, unitName, onChange, onBlur, error, maxLength }: PriceInputProps) => {
  const [text, setText] = useState('');
  const [textIsNan, setTextIsNan] = useState(false);

  return (
    <div className="priceInputWrapper">
      <div className="priceInput">             
      <span className="priceInput_label">{label}</span>   
        <input
          type="text"
          inputMode="numeric"
          name={name}
          value={price || text}
          disabled={disabled === true}
          placeholder={placeholder ??  '入力してください'}
          onChange={(e) => {
            // 全角を半角に変換したかったがなぜか全角で数字を入力するとe.target.valueが1１などになるのでやめる
            //const num = Number(toHalfWidthNumber(e.target.value));
            const num = Number(e.target.value);
            if (e.target.value && !isNaN(num)) {
              setTextIsNan(false);
              setText(num.toString());
              onChange(num);
            } else {
              setTextIsNan(true);
              setText(e.target.value);
              onChange(null);
            }
          }}
          onBlur={(e) => {
            onBlur?.(e);
          }}
          autoComplete="off"
          maxLength={maxLength}
        />
        <span className="priceInput_unit">{unitName}</span>
      </div>
      {(textIsNan || error) && (
        <FormError className="priceInputWrapper_error" error={error}/>
      )}
    </div>
  );
};
